export default { 
  AccountSetting: require('./AccountSetting').default,
}